//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../Features/Features.FeatureBuilder.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[0,"AssignWeldPMI",1,0],[1,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[1,"ContourDepth",0,"Expression",0],[1,"ContourHeight",0,"Expression",0],[0,"ContourType",1,0],[1,"Edge1",0,"Section",0],[1,"Face1",0,"ScCollector",0],[1,"Face2",0,"ScCollector",0],[0,"FieldWeld",1,0],[0,"SeedFace1",1,"Face",0],[0,"SeedFace2",1,"Face",0]],[],[]];
SPLM.Weld.PlugSlotBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.PlugSlotBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.PlugSlotBuilder.EnumContour = Object.freeze({
    "None" : "None", "Convex" : "Convex", "Flush" : "Flush", "Concave" : "Concave"});

SPLM.Weld.PlugSlotBuilder.ArcProcessEnum = Object.freeze({
    "Gmaw" : "Gmaw", "Gtaw" : "Gtaw", "Gtac" : "Gtac", "Smaw" : "Smaw", "Paw" : "Paw"});

export default SPLM;